import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { IMainState } from 'store/states'
import * as fromActions from 'store/actions/hierarchy.action'
import { RankmiTable } from '@rankmi/rankmi-table'
import { generateTableLocale } from 'helpers/translations.helper'
interface IProps {
  searchText: string
  handleSearch: any
}

const Table: React.FC<IProps> = ({ searchText, handleSearch }) => {
  const { t } = useTranslation()

  const {
    list,
    total,
    loading: hierarchyLoading,
  } = useSelector(({ hierarchy }: IMainState) => hierarchy)

  const searchTextRef = useRef([] as any)

  const dispatch = useDispatch()

  const [page, setPage] = useState(1)
  const [perPage] = useState(10)
  const [sort] = useState({})
  const [loading, setLoading] = useState(true)
  const [dataSource, setDatasource] = useState([] as any)
  const [columnHeaders, setColumnHeaders] = useState([] as any)
  const [translations, setTranslations] = useState(generateTableLocale())

  const prefix = 'configuration.hierarchy.list'
  const translateHeaderPrefix = `${prefix}.headers`
  useEffect(() => {
    setTranslations(() =>
      generateTableLocale({
        header: {
          rowsCount_plural: t(`${prefix}.rowsCount_plural`),
          rowsCount: t(`${prefix}.rowsCount`),
        },
      })
    )
  }, [t])

  useEffect(() => {
    setLoading(hierarchyLoading)
  }, [hierarchyLoading])

  useEffect(() => {
    setLoading(true)
    searchTextRef.current = searchText

    const timer = setTimeout(() => {
      dispatch({
        type: fromActions.HIERARCHY_LIST_GET,
        payload: {
          page,
          searchText,
          sort,
          perPage,
        },
      })
    }, 1000)
    return () => clearTimeout(timer)
  }, [page, sort, searchText, perPage, dispatch])

  useEffect(() => {
    setDatasource(
      list.map(({ id, name, code, parentName }: any) => ({
        key: id,
        name,
        code,
        parentName,
      }))
    )
  }, [list])

  useEffect(() => {
    setColumnHeaders([
      {
        title: t(`${translateHeaderPrefix}.name`),
        key: 'name',
        /* sorteable: true, */
      },
      {
        title: t(`${translateHeaderPrefix}.code`),
        key: 'code',
        /* sorteable: true, */
      },
      {
        title: t(`${translateHeaderPrefix}.parentName`),
        key: 'parentName',
        /* sorteable: true, */
      },
    ])
  }, [t, translateHeaderPrefix])

  return (
    <RankmiTable
      columnHeaders={columnHeaders}
      data={dataSource}
      total={total}
      currentPage={page}
      loading={loading}
      search={searchText}
      onSearch={handleSearch}
      /* No se implementará ordenamiento por ahora, ya que no esta el backend terminado */
      /* onSortChange={(sortData: any) => {
        setSort(sortData)
      }} */
      onPaginationChange={(currentPage: number) => setPage(currentPage)}
      /* No se implementara filtrar por cantidad de filas, ya que no esta el backend terminado */
      /* onRowsPerPageChange={(itemsPerPage: number) => setPerPage(itemsPerPage)} */
      locale={translations}
    />
  )
}

export default Table
